const { Mixin } = require('@xingternal/hops');

class LoginStateRuntimeMixin extends Mixin {
  enhanceServerData(serverData, _req, res) {
    return {
      ...serverData,
      login: res.locals.login,
    };
  }
}

module.exports = LoginStateRuntimeMixin;
